import SafeBoundary from './SafeBoundary';

export default SafeBoundary;
